import { IMobileNativeSelectOption } from '~/src/dash/components/dropdowns/MobileNativeSelect';

export enum EDashboardTab {
  Overview = 0,
  Live,
}

export interface IMobileDashboardConfig {
  defaultState: {
    tab: number;
  };
  tabs: IMobileNativeSelectOption[];
}

export const mobileDashboardConfig = {
  defaultState: {
    tab: EDashboardTab.Overview,
  },
  tabs: [
    { label: 'Overview', value: EDashboardTab.Overview },
    { label: 'Live', value: EDashboardTab.Live },
  ],
} as IMobileDashboardConfig;
